import { useEffect, useRef } from "react";
import { useReducedMotion } from "framer-motion";

// Self-hosted brand aurora loop (generated asset: public/videos/hero-loop.mp4).
// Reduced-motion users get the static poster frame instead of autoplay.
const HeroVideo = () => {
  const reduced = useReducedMotion();
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return undefined;
    const onVisibility = () => {
      if (document.hidden) v.pause();
      else v.play().catch(() => {});
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, []);

  if (reduced) {
    return (
      <img
        src="/videos/hero-poster.jpg"
        alt=""
        aria-hidden="true"
        data-testid="hero-poster-frame"
        className="absolute inset-0 h-full w-full object-cover"
      />
    );
  }

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      poster="/videos/hero-poster.jpg"
      aria-hidden="true"
      data-testid="hero-background-video"
      className="absolute inset-0 h-full w-full object-cover"
    >
      <source src="/videos/hero-loop.mp4" type="video/mp4" />
    </video>
  );
};

export default HeroVideo;
